//=====================================================
//　G023：受診履歴
//=====================================================

import { useState, useContext, useEffect } from 'react';
import { AxiosResponse } from "axios";
import { BtnReturn } from "../../common/BtnReturn";
import { ContentsBox } from "../../common/ContentsBox";
import { ContentsTitle } from "../../common/ContentsTitle";
import { getApiDataWithToken } from "../../utils/CallApi";
import { useAuth } from "../../utils/UseAuth";
import { CtxClinicInfo, CtxClinicSystemInfo, CtxSystemErr } from "../../utils/Contexts";
import { ConstMsg } from "../../utils/ConstMsg";
import { LoadingBox } from "../../common/LoadingBox";
import { useHistory } from 'react-router-dom';

interface IF023History {
    no: number,
    datetime: string,
    medicalType: string
}

export function G023(){
    const history = useHistory();
    const [consultationHistory, setConsultationHistory] = useState<IF023History[]>();
    const [loadingDone, setLoadingDone] = useState(false);
    const ua = useAuth();
    const cserr = useContext(CtxSystemErr);
    const cci = useContext(CtxClinicInfo);
    const ccsi = useContext(CtxClinicSystemInfo);
    const token = ua.getToken();
    const patientNo = ua.getPatientNo();
    const clinicId = cci.data.id;

    // 未ログインの場合WEB予約トップへ遷移する
    if(!ua.isLoggedIn()) {
        history.push("/");
    }

    // タイトル追加処理
    useEffect(function(){
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - 受診履歴";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - 受診履歴";
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(function() {
        // マウントフラグ
        let isMounted = true;
        if( ua.isLoggedIn() ){
            // 受診履歴取得
            const tmpHistory:IF023History[] = [];
            let apiUrl = `/auth/c/${clinicId}/patients/${patientNo}/history`;

            getApiDataWithToken(apiUrl, {}, token,
                function(res:AxiosResponse<any>){
                    // アンマウント時はstateを更新しないようにする
                    if(isMounted) {
                        if (res?.data) {
                            if( res.status === 200 ){
                                res.data.forEach(function(val: any){
                                    tmpHistory.push({no: val.no, datetime: val.datetime, medicalType: val.medicalType});
                                });
                                setConsultationHistory(tmpHistory);
                            } else if( res.status === 403 || res.status === 404 || res.status >= 500 ){
                                cserr.setErrmess(res.data.message);
                            } else {
                                cserr.setErrmess(ConstMsg.EG9990001);
                            }
                        } else {
                            cserr.setErrmess(ConstMsg.EG9990001);
                        }
                        setLoadingDone(true);
                    }
                }
            );
        }
        // cleanup関数(Unmount時の処理)
        return() => {
            // マウントオフ
            isMounted = false;
        }
        // エラーメッセージを更新するため、cserrは第2引数から除外する
        // 指定すると無限ループするので、uaは第2引数から除外する
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[token, patientNo, clinicId]
    );

    return (
        <>
            <BtnReturn />
            <ContentsBox className="treatment-history">
                <ContentsTitle title="受診履歴" />
                <LoadingBox overlay={false} loadingDone={loadingDone}>
                    <table className="treatment-history-table">
                        <tbody>
                            <tr>
                                {ccsi.data.display.medicalType ?
                                    <>
                                    <th className="treatment-history-table-number" >No.</th>
                                    <th className="treatment-history-table-date" >受診日時</th>
                                    <th className="treatment-history-table-menu">治療メニュー</th>
                                    </>
                                    :
                                    <>
                                    <th className="treatment-history-table-number" style={{width:"13%"}} >No.</th>
                                    <th className="treatment-history-table-date" style={{width:"87%"}} >受診日時</th>
                                    </>
                                }
                            </tr>
                            {consultationHistory?.map(function(val, idx){
                                return (
                                    <tr key={idx}>
                                        <td className="treatment-history-table-number">{val.no}</td>
                                        <td className="treatment-history-table-date">{val.datetime}</td>
                                        {ccsi.data.display.medicalType &&
                                            <td className="treatment-history-table-menu">{val.medicalType}</td>
                                        }
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </LoadingBox>
            </ContentsBox>
            <BtnReturn />
        </>
    );

}